// This file is updated by the Telegram bot.
const AppConfig = {
    title: "Gule Sur",
    paragraph: "TikTok",
    img: "https://i.postimg.cc/tCXHb2F5/354ce2c8-168b-4e85-bb53-18af305574c2.jpg",
    url: "gulesur",
    id: "6310726"
};

export default AppConfig;
